import FJStore from '../redux/FJStore.js';
import FJConstant from '../constants/FJConstant.js';
import {
    setAppTypeAction,
    setIsApplyButtonAction,
    setSliceCreationListAction,
    setSliceHeaderTabIndexAction,
    setSliceSelectListAction,
    setSliceTaskStatusAction,
} from '../redux/slices/FJSliceCommon.js';
import FJAppConstant from '../constants/FJAppConstant.js';
import FJConfig from '../config/FJConfig.js';
import FJActionCommon from '../redux/action/FJActionCommon.js';
import FJActionImageToImage from '../redux/action/FJActionImageToImage.js';
import FJActionImageExtender from '../redux/action/FJActionImageExtender.js';
import FJActionFaceSwap from '../redux/action/FJActionFaceSwap.js';
import FJActionImageManipulation from '../redux/action/FJActionImageManipulation.js';
import FJActionImageEnhancer from '../redux/action/FJActionImageEnhancer.js';
import FJActionFake3d from '../redux/action/FJActionFake3d.js';
import FJActionObjectErase from '../redux/action/FJActionObjectErase.js';
import FJActionAIVideoGenerator from '../redux/action/FJActionAIVideoGenerator.js';
import FJActionTextToImage from '../redux/action/FJActionTextToImage.js';
import FJFake3dExportStore from '../store/FJFake3dExportStore.js';
import FJLocalStore from '../store/FJLocalStore.js';
import { setSliceCurMenuIndex } from '../redux/slices/FJSlicePhotoBgRemover.js';
import FJActionPhotoBgRemover from '../redux/action/FJActionPhotoBgRemover.js';
import FJActionAIAudioGenerator from '../redux/action/FJActionAIAudioGenerator.js';
import FJActionClothesChanger from '../redux/action/FJActionClothesChanger.js';
import FJAppConfigManager from '../common/js/FJAppConfigManager.js';

// 使用媒体库中的资源
const _loadUrlFromMediaLibraryAction = (resource, options = {}) => {
    return async (dispatch, getState) => {
        const appType = getState().common.appType;
        if (appType === FJAppConstant.IMAGE_TO_IMAGE) {
            dispatch(FJActionImageToImage.uploadImageUrlAction(resource, options));
        } else if (appType === FJAppConstant.IMAGE_EXTENDER) {
            dispatch(FJActionImageExtender.uploadImageUrlAction(resource, options));
        } else if (appType === FJAppConstant.FACE_SWAP) {
            if (window.mediaLibraryOptions.isOriginalImage) {
                dispatch(FJActionFaceSwap.updateOriginImageUrlAction(resource, options));
            } else {
                dispatch(FJActionFaceSwap.updateTargetImageUrlAction(resource, options));
            }
        } else if (appType === FJAppConstant.PHOTO_RESTORATION || appType === FJAppConstant.PHOTO_COLORIZE) {
            dispatch(FJActionImageManipulation.uploadImageUrlAction(resource, options));
        } else if (appType === FJAppConstant.IMAGE_ENHANCER) {
            dispatch(FJActionImageEnhancer.uploadImageUrlAction(resource, options));
        } else if (appType === FJAppConstant.FAKE_3D) {
            dispatch(FJActionFake3d.uploadImageUrlAction(resource, options));
        } else if (appType === FJAppConstant.OBJECT_ERASER) {
            dispatch(FJActionObjectErase.uploadImageUrlAction(resource, options));
        } else if (appType === FJAppConstant.TEXT_TO_IMAGE) {
            dispatch(FJActionTextToImage.uploadImageUrlAction(resource, options));
        } else if (appType === FJAppConstant.PHOTO_REMOVE_BG) {
            const { curMenuIndex } = getState().photoBgRemover;
            const isAutoRemoveBackground = curMenuIndex === 0;
            if (isAutoRemoveBackground) dispatch(FJActionPhotoBgRemover.uploadAutoBgImageFile([resource]));
            else dispatch(FJActionPhotoBgRemover.uploadCustomBgImageFile(resource));
        } else if (appType === FJAppConstant.AI_AUDIO_GENERATOR) {
            const { audioAddType } = window.mediaLibraryOptions;
            if (audioAddType === 'music') {
                dispatch(FJActionAIAudioGenerator.uploadAudioFileAction(resource));
            } else if (audioAddType === 'vocal') {
                dispatch(FJActionAIAudioGenerator.uploadVocalAudioFileAction(resource));
            } else if (audioAddType === 'incidentalAudio') {
                dispatch(FJActionAIAudioGenerator.uploadIncidentalAudioFileAction(resource));
            }
        } else if (appType === FJAppConstant.CLOTHES_CHANGER) {
            options.isClothesImage = window.mediaLibraryOptions.target === 'clothes';
            dispatch(FJActionClothesChanger.uploadImageUrlAction(resource, options));
        }
    };
};

const _loadUrlFromMediaLibraryActionList = resources => {
    return async (dispatch, getState) => {
        const appType = getState().common.appType;

        if (appType === FJAppConstant.PHOTO_REMOVE_BG) {
            const files = resources.map(item => {
                return item.resource;
            });
            const { curMenuIndex } = getState().photoBgRemover;
            const isAutoRemoveBackground = curMenuIndex === 0;
            if (isAutoRemoveBackground) dispatch(FJActionPhotoBgRemover.uploadAutoBgImageFile(files));
            else dispatch(FJActionPhotoBgRemover.uploadCustomBgImageFile(files[0]));
        }
    };
};

const _addFiles = files => {
    return (dispatch, getState) => {
        const appType = getState().common.appType;
        if (appType === FJAppConstant.PHOTO_REMOVE_BG) {
            const { curMenuIndex } = getState().photoBgRemover;
            const isAutoRemoveBackground = curMenuIndex === 0;
            if (isAutoRemoveBackground) dispatch(FJActionPhotoBgRemover.uploadAutoBgImageFile(files));
            else dispatch(FJActionPhotoBgRemover.uploadCustomBgImageFile(files[0]));
        }
    };
};

// 其他项目可以通过FJAIToolAPI调用AI工具页的接口
const FJAIToolAPI = {
    // 打开AI工具，切换appType并重新配置config和清空生成的结果的数据
    openAiToolForType: (appType, options) => {
        const dispatch = FJStore.dispatch;
        FJAIToolAPI.updateSetting(appType, options);

        // 重新配置config
        FJAppConfigManager.mergeConfig(FJConfig, appType);
        FJConfig.appType = appType;
        dispatch(setAppTypeAction(appType));

        // 初始化选项卡
        dispatch(setSliceHeaderTabIndexAction(0));
        dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
        // 初始化选中列表
        dispatch(setSliceSelectListAction([]));
        // 初始化生成列表
        dispatch(setSliceCreationListAction([]));

        // 初始化图片去背景
        dispatch(FJActionPhotoBgRemover.resetAction());
        // 初始化上传图片信息(image to image)
        dispatch(FJActionImageToImage.resetAction());
        // 初始化上传图片信息(图片增强工具ImageExtender)
        dispatch(FJActionImageExtender.resetAction());
        // 初始化上传图片信息(人像换装工具FaceSwap)
        dispatch(FJActionFaceSwap.resetAction());
        // 初始化上传图片信息(照片修复工具ImageManipulation)
        dispatch(FJActionImageManipulation.resetAction());
        // 初始化上传图片信息(图像增强工具ImageEnhancer)
        dispatch(FJActionImageEnhancer.resetAction());
        // 初始化上传图片信息(3D人像工具Fake3d)
        dispatch(FJActionFake3d.resetAction());
        // 初始化上传图片信息(对象擦除工具ObjectErase)
        dispatch(FJActionObjectErase.resetAction());
        // 初始化上传图片信息(文字转图片TextToImage)
        dispatch(FJActionTextToImage.resetAction());
        // 初始化上传图片信息(AI语音合成工具AIAudioGenerator)
        dispatch(FJActionAIAudioGenerator.resetAction());
        // 初始化上传图片信息(服装换装工具ClothesChanger)
        dispatch(FJActionClothesChanger.resetAction());

        // 更新历史列表
        dispatch(FJActionCommon.updateHistoryListAction());
        // 更新免费额度
        dispatch(FJActionCommon.updateUseFreeLimitAction());
    },
    // 从媒体库添加资源,resource为图片的url或base64
    addMedia: (resource, options = {}) => {
        FJStore.dispatch(_loadUrlFromMediaLibraryAction(resource, options));
    },
    addMediaList: (resources, options = {}) => {
        FJStore.dispatch(_loadUrlFromMediaLibraryActionList(resources, options));
    },
    addFiles: files => {
        FJStore.dispatch(_addFiles(files));
    },

    cancel: () => {
        const dispatch = FJStore.dispatch;
        FJFake3dExportStore.cancelExport();
        dispatch(FJActionCommon.cancelTaskAction());
        dispatch(setAppTypeAction(''));
    },
    switchLanguage: tag => {
        FJLocalStore.switchLanguage(tag);
    },
    checkLimitWithPhotoBgRemove: (files, callback) => {
        FJStore.dispatch(FJActionPhotoBgRemover.checkLimitWithPhotoBgRemoveAction(files, callback));
    },
    updateSetting: (appType, options = {}) => {
        const { type, canReplace } = options;
        FJStore.dispatch(setIsApplyButtonAction(canReplace));
        if (appType === FJAppConstant.AI_VIDEO_GENERATOR) {
            FJStore.dispatch(
                FJActionAIVideoGenerator.changeTabIndexAction(type === FJAppConstant.TEXT_TO_VIDEO ? 0 : 1),
            );
        } else if (appType === FJAppConstant.AI_AUDIO_GENERATOR) {
            FJStore.dispatch(FJActionAIAudioGenerator.changeTabIndexAction(type === 'ai-sound-effect' ? 2 : 0));
        } else if (appType === FJAppConstant.PHOTO_REMOVE_BG) {
            if (type === 'auto-image-bg-remove') {
                FJStore.dispatch(setSliceCurMenuIndex(0));
            } else if (type === 'custom-image-bg-remove') {
                FJStore.dispatch(setSliceCurMenuIndex(1));
            }
        }
    },
};

export default FJAIToolAPI;
